import { render, staticRenderFns } from "./SsoPage.vue?vue&type=template&id=513cc9f6"
import script from "./SsoPage.vue?vue&type=script&lang=ts"
export * from "./SsoPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports